module.exports = __webpack_public_path__ + "img/avatar-group-hover-last.bcc03feb.svg";